/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import getText from 'context/language/getText';
import { EVENT_NAMES } from 'analytics/constants';
import track from 'analytics/utilities/track';
import Layout from './layout';
import { useStyles } from './styled';
import { notifyBugsnagClient } from '../bugsnag';
import { severity } from '../bugsnag/constants';

const displayProps = {
  header: getText('page404.errorMsg'),
  line1: getText('page404.theWorkersYouSeek'),
  line2: getText('page404.thePageYouSeek'),
};

const Page404 = ({ location, history, ...rest }) => {
  const classes = useStyles();
  notifyBugsnagClient('Page404', (event) => {
    const tempEvent = {
      ...event,
      severity: severity.INFO,
      request: location
    };
    return tempEvent;
  });
  track(EVENT_NAMES.ERROR, {
    ...rest,
    status: 404,
    location,
    history,
  });
  return (
    <div className={classes.background}>
      <Layout {...displayProps} />
    </div>
  );
};

Page404.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
  }),
  history: PropTypes.object,
};

Page404.defaultProps = {
  location: { pathname: '', search: '' },
  history: {},
};

export default Page404;
